export function safeInternalPath(path: unknown): string | null {
  if (typeof path !== "string") return null;
  if (path[0] !== "/" || path[1] === "/" || path[1] === "\\") return null;

  const origin = window.location.origin;
  let url: URL;
  try {
    url = new URL(path, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin) return null;

  const result = url.pathname + url.search + url.hash;

  if (result[0] !== "/" || result[1] === "/" || result[1] === "\\") return null;

  try {
    if (new URL(result, origin).origin !== origin) return null;
  } catch {
    return null;
  }

  return result;
}
